module.exports = __webpack_public_path__ + "media/images/application/template/footer-logo-6-e05e658d175894abac08f4e73be837cc.jpg";